var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-link",on:{"click":function($event){return _vm.back(_vm.linkTo)}}},[_vm._v("返回主页")])
}
var staticRenderFns = []

export { render, staticRenderFns }